import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const lojas = () => {
  const auth = useAuth();

  async function list() {
    let retorno = [];
    try {
      const {data} = await http.get('/stores', auth.getBearer());
      retorno = data;
    } catch (error) {
      console.log(error?.response?.data);
    }
    return retorno;
  }

  async function createItem(loja) {
    try {
      const {data} = await http.post('/stores', loja, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      // Ex.: bloqueio por limite do plano (ver EnforcesPlanLimits no
      // backend) — a tela precisa da mensagem real, não só saber que falhou.
      return error?.response?.data?.message ?? 'Não foi possível cadastrar a loja.';
    }
  }

  async function updateItem(loja) {
    try {
      const {data} = await http.put('/stores/'+loja.id, loja, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function deleteItem(id) {
    try {
      const {data} = await http.delete('/stores/'+id, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  return {list, createItem, updateItem, deleteItem}
}
